export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="text-xs font-bold tracking-widest text-cyan-500 mb-4">
          GET IN TOUCH
        </div>
        <h2 className="text-5xl font-bold text-gray-900 mb-6">
          Ready to Secure
          <br />
          Your Connection?
        </h2>
        <p className="text-gray-600 max-w-md mx-auto mb-12 text-base">
          Contact us today to learn more about our VPN solutions and how we can protect your digital privacy
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-cyan-500 flex items-center justify-center mb-4">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">
              EMAIL
            </div>
            <a 
              href="mailto:contact@distriemltda.com" 
              className="text-lg font-bold text-gray-900 hover:text-cyan-500 transition-colors break-all"
            >
              contact@distriemltda.com
            </a>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-cyan-500 flex items-center justify-center mb-4">
              <i className="ri-phone-line text-2xl text-white"></i>
            </div>
            <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">
              PHONE
            </div>
            <a 
              href="tel:+16507302658" 
              className="text-lg font-bold text-gray-900 hover:text-cyan-500 transition-colors"
            >
              +1 650 730 2658
            </a>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-cyan-500 flex items-center justify-center mb-4">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">
              ADDRESS
            </div>
            <div className="text-lg font-bold text-gray-900">
              CARRERA 5 27 08
              <br />
              Pereira, Colombia
            </div>
          </div>
        </div>

        <p className="text-sm italic text-gray-500">
          Business inquiries welcome
        </p>
      </div>
    </section>
  );
}
